import React from "react";
import { Route, Routes } from "react-router-dom";

import { InterviewBookingPage } from "@/client_app/components/InterviewBookingPage";
import { NotFound } from "@/organization_app/components/NotFound";
import {
  APPLICATIONS_PATH,
  INTERVIEW_PAGE_PATH,
  JOBS_PAGE_PATH,
  POSITIONS_PATH,
  REFERRALS_PATH,
} from "@/organization_app/config";
import { invoicingsRoutes } from "@/organization_app/features/invoicings/routes";
import { ApplicationsPage } from "@/organization_app/features/jobs/components/ApplicationsPage";
import { JobsPage } from "@/organization_app/features/jobs/components/JobsPage";
import { ReferralsPage } from "@/organization_app/features/jobs/components/ReferralsPage";
import { PositionsPage } from "@/organization_app/features/positions/components/PositionsPage";

export const AppRoutes = (): JSX.Element => {
  return (
    <Routes>
      {invoicingsRoutes}
      <Route path={APPLICATIONS_PATH} element={<ApplicationsPage />} />
      <Route path={JOBS_PAGE_PATH} element={<JobsPage />} />
      <Route
        path={INTERVIEW_PAGE_PATH}
        element={<InterviewBookingPage isAdmin={true} />}
      />
      <Route path={POSITIONS_PATH} element={<PositionsPage />} />
      <Route path={REFERRALS_PATH} element={<ReferralsPage />} />
      <Route path='*' element={<NotFound />} key='not-found-routes' />
    </Routes>
  );
};
